<div class="container">
  <fgbcl-marketplace-list
    [isList]="true"
    [showSortBar]="false"
    [marketplaceItemTypes]="[0, 1, 2]"
    [marketplaceItemView]="true"
    [defaultSort]="2"
  ></fgbcl-marketplace-list>
</div>
